/*
  Colors are organized around 3 main CSS properties:
  * Text {color: @color}
  * Border {border-color: @border}
  * Background {background: @background}

  If default values for main selectors needs to be modified we add additional namespaces
  e.g. @alt-color, @alt-background, @alt-background-dark
*/

export enum Colors {
  // TEXT
  color = '#4d6072',
  colorLight = '#718497',
  colorLighter = '#98b1bd',
  colorDarker = '#2e3e4d',
  colorDark = '#4e616a',
  colorPrimary = '#1999e3',
  colorPrimaryDark = '#117cba',
  colorPrimaryDarker = '#0c6090',
  colorPrimaryDarkest = '#083f5e',
  colorDarkest = '#283542',
  colorDarkestX = '#1f2b38',

  // BACKGROUNDS
  background = '#f0f4f7',
  backgroundLight = '#f8fafb',
  backgroundDark = '#e5ebef',
  backgroundDarker = '#d2dde5',
  backgroundGradient = 'linear-gradient(-180deg, #fff, #f5f8f9 99%)',

  gradientLaunch = 'linear-gradient(45deg, #215ab7 0%, #1999e3 50%, #7cccfa 100%)',
  gradientScale = 'linear-gradient(45deg, #117cba 0%, #31bd95 50%, #9be398 100%)',
  gradientLead = 'linear-gradient(45deg, #174298 0%, #7148bd 52%, #af7ee6 100%)',

  // BORDERS
  border = '#c9d7df',
  borderMiddle = '#d6e0e5',
  borderLight = '#e6f0f6',
  borderDark = '#bccdd7',
  borderDarker = colorLighter,
  borderViolet = '#5160af',
  borderSuccess = '#abc290',
  borderWarning = '#cccca4',

  // ALTERNATIVE
  altBackground = colorDarkest,
  altBorder = color,
  altLightBackground = altBorder,

  // PRIVATE
  privateBackgroundLight = '#fffff0',

  // MESSAGE
  informationColor = '#343c40',
  informationBackground = '#d1eeff',

  warningInfoColor = '#87795f',
  warningBackground = '#ffffcd',

  errorBorder = '#403735',
  errorBackground = '#ffdbd4',

  successBackground = '#d6f3b4',
  successBackgroundLight = 'rgba(214, 243, 180, 0.5)',

  // SPECIAL
  colorRed = '#f83244',
  colorGreen = '#4fc510',
  colorOrange = '#f55f0e',
  colorViolet = '#7986cb',
  colorYellow = '#ecb731',
  colorScaleGreen = '#31bd95',
  colorLeadPurple = '#7148bd',
  colorBittersweet = '#fe6363',
  colorGold = '#bd910c',

  // SELECTORS (In progress)
  // :hover, :selection, :disabled
  hoverBackground = '#f1faff',
  hoverBackgroundDark = border,
  hoverScaleGreen = '#1ea275',
  hoverLeadPurple = '#512fa2',

  selectedBorder = '#b6c4cc',
  selectedBackground = '#e4f5ff',

  // SOCIAL MEDIA
  facebookColor = '#41599c',
  twitterColor = '#3dacf0',
  gplusColor = '#d34836',
  linkedinColor = '#2b80b5',

  // CALENDAR
  personalColor = '#f09300',

  // CONTEXTS
  // Context ALT
  contextAltColorLight = '#fff',
  contextAltColor = border,
  contextAltColorDark = colorLighter,

  contextAltBackgroundDarkX = colorDarkestX,
  contextAltBackground = altBackground,
  contextAltBackgroundLight = altBorder,

  contextAltBorder = altBorder,
  contextAltBorderLight = '#627a90',

  // Context PRIVATE
  contextPrivateColorLighter = color,
  contextPrivateColor = colorDarkest,

  contextPrivateBorder = borderWarning,
  contextPrivateBorderDarker = borderWarning,

  contextPrivateBackground = warningBackground,
  contextPrivateBackgroundDarker = '#f2f2c3',
  contextPrivateBackgroundLighter = '#ffffe7',

  // Context ERROR
  contextErrorBorder = '#ccafaa',
}
